<template>
  <div class="nav">
    <router-link :to="'/confirmation?ExhID='+ExhID">
      <span>首页</span>
    </router-link>
    <router-link :to="'/basicInfo?ExhID='+ExhID">
      <span>个人信息</span>
    </router-link>
    <router-link v-if="!showQues" :to="'/questionnaire?ExhID='+ExhID">
      <span>调查问题</span>
    </router-link>
    <router-link v-if="showGroup" :to="'/groupRegister?ExhID='+ExhID">
      <span>团组注册</span>
    </router-link>
    <router-link v-if="showHelp" :to="'/helpRegister?ExhID='+ExhID">
      <span>协助注册</span>
    </router-link>
    <router-link v-if="showAc" :to="'/meeting?ExhID='+ExhID">
      <span>会议报名</span>
    </router-link>
    <router-link v-if="showInvite" :to="'/inviteOpera?ExhID='+ExhID">
      <span>邀请注册</span>
    </router-link>
    <!-- <router-link to="/changePassword">
      <span>修改密码</span>
    </router-link>-->
    <router-link :to="'/login?ExhID='+ExhID">
      <span>退出</span>
    </router-link>
  </div>
</template>
<script>
export default {
  data() {
    return {
      ExhID: sessionStorage.getItem('ExhID'),
      PsnID: sessionStorage.getItem('PsnID') || '',
      showQues: sessionStorage.getItem('IfSubmit') ? JSON.parse(sessionStorage.getItem('IfSubmit')) : false, // 默认有问卷
      showGroup: sessionStorage.getItem('IsEnableGroupRegist') ? JSON.parse(sessionStorage.getItem('IsEnableGroupRegist')) : true,
      showHelp: sessionStorage.getItem('IsEnableHelpRegist') ? JSON.parse(sessionStorage.getItem('IsEnableHelpRegist')) : true,
      showInvite: sessionStorage.getItem('IsEnableInviteRegist') ? JSON.parse(sessionStorage.getItem('IsEnableInviteRegist')) : true,
      showAc: sessionStorage.getItem('IsRegistActivity') ? JSON.parse(sessionStorage.getItem('IsRegistActivity')) : true
    }
  },
  mounted() {},
  methods: {
  }
}
</script>
<style lang="scss" scoped>
.nav {
  text-align: center;
  margin: 30px auto;
}
.nav .router-link-active span {
  color: #000;
}
.nav a:after {
  content: '|';
  padding-left: 2%;
  color: #c7c7c7;
}
.nav span {
  cursor: pointer;
  padding-left: 2%;
  color: #909399;
  font-weight: bold;
}
.nav a:last-child:after {
  content: '';
}
.nav a {
  text-decoration: none;
}
</style>



// WEBPACK FOOTER //
// src/components/Nav.vue